// Photo filenames for Biketober Fest 2011
const BIKETOBER_FEST_2011 = [
  'events-rolling-thunder-biketoberfest-2011-112_16530536175_z.jpg',
  'events-rolling-thunder-biketoberfest-2011-113_16343059420_c.jpg',
  'events-rolling-thunder-biketoberfest-2011-114_16504516036_c.jpg',
  'rolling-thunder-biketoberfest-2011-1_16529474982_z.jpg',
  'rolling-thunder-biketoberfest-2011-6_16530542455_c.jpg',
  'rolling-thunder-biketoberfest-2011-7_16344246879_c.jpg',
  'rolling-thunder-biketoberfest-2011-10_16343065930_c.jpg',
  'rolling-thunder-biketoberfest-2011-11_16528808061_c.jpg',
  'rolling-thunder-biketoberfest-2011-12_16504515326_c.jpg',
  'rolling-thunder-biketoberfest-2011-13_15910339683_c.jpg',
  'rolling-thunder-biketoberfest-2011-14_16529474012_z.jpg',
  'rolling-thunder-biketoberfest-2011-16_16344608297_z.jpg',
  'rolling-thunder-biketoberfest-2011-17_16528807311_z.jpg',
  'rolling-thunder-biketoberfest-2011-19_16530541185_z.jpg',
  'rolling-thunder-biketoberfest-2011-20_15910338883_z.jpg',
  'rolling-thunder-biketoberfest-2011-21_16342833398_z.jpg',
  'rolling-thunder-biketoberfest-2011-22_16344607677_c.jpg',
  'rolling-thunder-biketoberfest-2011-23_16530540695_z.jpg',
  'rolling-thunder-biketoberfest-2011-25_15907944704_c.jpg',
  'rolling-thunder-biketoberfest-2011-26_16529472962_z.jpg',
  'rolling-thunder-biketoberfest-2011-27_16343064210_z.jpg',
  'rolling-thunder-biketoberfest-2011-32_16344245029_z.jpg',
  'rolling-thunder-biketoberfest-2011-34_16504513446_z.jpg',
  'rolling-thunder-biketoberfest-2011-35_16343063780_z.jpg',
  'rolling-thunder-biketoberfest-2011-38_16343063570_c.jpg',
  'rolling-thunder-biketoberfest-2011-41_16342832298_l.jpg',
  'rolling-thunder-biketoberfest-2011-42_16529472062_z.jpg',
  'rolling-thunder-biketoberfest-2011-43_15907943274_z.jpg',
  'rolling-thunder-biketoberfest-2011-48_16529471712_z.jpg',
  'rolling-thunder-biketoberfest-2011-50_16343062860_z.jpg',
  'rolling-thunder-biketoberfest-2011-51_16344605967_c.jpg',
  'rolling-thunder-biketoberfest-2011-53_16504511946_z.jpg',
  'rolling-thunder-biketoberfest-2011-55_16504511826_c.jpg',
  'rolling-thunder-biketoberfest-2011-58_15910336053_z.jpg',
  'rolling-thunder-biketoberfest-2011-60_16504511496_z.jpg',
  'rolling-thunder-biketoberfest-2011-61_15907942114_z.jpg',
  'rolling-thunder-biketoberfest-2011-62_15907941954_z.jpg',
  'rolling-thunder-biketoberfest-2011-66_16344605037_z.jpg',
  'rolling-thunder-biketoberfest-2011-67_16343061430_z.jpg',
  'rolling-thunder-biketoberfest-2011-70_15907941574_z.jpg',
  'rolling-thunder-biketoberfest-2011-71_16529470002_z.jpg',
  'rolling-thunder-biketoberfest-2011-72_16344604367_z.jpg',
  'rolling-thunder-biketoberfest-2011-76_16342829758_z.jpg',
  'rolling-thunder-biketoberfest-2011-79_16344604027_z.jpg',
  'rolling-thunder-biketoberfest-2011-86_16528803161_c.jpg',
  'rolling-thunder-biketoberfest-2011-88_16504510066_z.jpg',
  'rolling-thunder-biketoberfest-2011-89_16529469062_c.jpg',
  'rolling-thunder-biketoberfest-2011-92_15910333983_z.jpg',
  'rolling-thunder-biketoberfest-2011-95_16344240939_z.jpg',
  'rolling-thunder-biketoberfest-2011-96_15910333833_z.jpg',
  'rolling-thunder-biketoberfest-2011-105_15910333763_z.jpg',
  'events-bikertoberfest-101511-4_15910333683_z.jpg',
  'events-bikertoberfest-101511-5_16504509336_z.jpg',
  'events-october-15-2011-open-house-ad_16504509266_z.jpg',
  'events-rolling-thunder-biketoberfest-2011-103_15907939524_z.jpg',
  'events-rolling-thunder-biketoberfest-2011-110_15910333353_z.jpg',
  'events-rolling-thunder-biketoberfest-2011-111_16344602867_z.jpg',
];

export default BIKETOBER_FEST_2011;
